import authHeader from "./auth-header";
import http from "./http-common";
class UserService {
	getPublicContent() {
		return http.get("/all");
	}

	getUserBoard() {
		return http.get("/user", { headers: authHeader() });
	}

	getModeratorBoard() {
		return http.get("/mod", { headers: authHeader() });
	}

	getAdminBoard() {
		return http.get("/admin", { headers: authHeader() });
	}

	getUserProfile() {
		return http.get("/profile", { headers: authHeader() });
	}

	updateUserProfile(userData) {
		return http.put("/profile", userData, { headers: authHeader() });
	}

	loginStatus() {
		return http.get("/loginstatus", { headers: authHeader() });
	}
}

export default new UserService();
